import {Col} from 'react-bootstrap';
import PropTypes from 'prop-types';

const MessageBody = ({children}) => (
  <Col xs={11} sm={6}>
    {children}
  </Col>
);

MessageBody.propTypes = {
  children: PropTypes.any
};

export default MessageBody;
